    <span mat-dialog-title class="pb-0"><a class="custom-link" mat-flat-button target="_blank" [mat-dialog-close]="true"><mat-icon>chevron_left</mat-icon>Back</a></span>
    <h1 mat-dialog-title>{{employeeTypeList[data.type - 1].header}}</h1>
    <mat-dialog-content>
        <mat-selection-list class="h-13rem add-employee-list" #employee [multiple]="false" (selectionChange)="onSelectionChange($event)">
            <mat-list-option *ngFor="let employee of employeeTypeList[data.type - 1].body" [value]="employee.value" [disabled]="employee.disabled">
                <span class="selection-title" matLine>{{employee.title}}</span>
                <p class="selection-description" matLine>{{employee.description}}</p>
            </mat-list-option>
        </mat-selection-list>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button class="custom-btn" mat-button [mat-dialog-close]="true" color="primary" (click)="addEmployee()">Next</button>
    </mat-dialog-actions>
